import React, { Suspense } from 'react';
import { useVoiceModeStore } from '@/store';

const LazyVoiceModeOverlay = React.lazy(() =>
  import('@/components/VoiceMode/VoiceModeOverlay')
);

/**
 * Lazy-mount shell for VoiceModeOverlay (~1.6k lines + voice/WebRTC stack).
 * Mounted only in `(app)` layouts — voice mode is never used on marketing pages (3.1.h).
 */
export default function VoiceModeOverlayHost() {
  const isActive = useVoiceModeStore((state) => state.isActive);

  if (!isActive) return null;

  return (
    <Suspense fallback={null}>
      <LazyVoiceModeOverlay />
    </Suspense>
  );
}
